import { FC, useState } from 'react';
import { Button, Popover, Tag } from 'antd';
import { TbInfoCircle } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import { RequiredOAuthApplicationField, requiredOAuthApplicationFieldDetails } from '../../readiness';
import { oauthApplicationCreationStepsByKey, OAuthApplicationFormSectionKey } from '../../steps';

interface RequiredFieldsPreviewPopoverProps {
    availableSteps: Record<OAuthApplicationFormSectionKey, boolean>;
    fields: RequiredOAuthApplicationField[];
    onSelect: (field: RequiredOAuthApplicationField) => void;
}

const RequiredFieldsPreviewPopover: FC<RequiredFieldsPreviewPopoverProps> = ({ availableSteps, fields, onSelect }) => {
    const { token } = useAntDesignTheme();
    const [open, setOpen] = useState(false);

    const content = (
        <div style={{ width: 248 }}>
            <small style={{ display: 'block', padding: '0.25rem 0.75rem', color: token.colorTextTertiary }}>
                Required Fields to Preview
            </small>
            <div style={{ marginTop: '0.25rem', borderTop: `1px solid ${token.colorBorderSecondary}` }}>
                {fields.map((field) => {
                    const details = requiredOAuthApplicationFieldDetails[field];
                    const section = oauthApplicationCreationStepsByKey[details.sectionKey];
                    const available = availableSteps[details.sectionKey];

                    return (
                        <Button
                            key={field}
                            block
                            type='text'
                            disabled={!available}
                            style={{
                                height: 'auto',
                                minHeight: '3.5rem',
                                borderRadius: 0,
                                borderBottom: `1px solid ${token.colorBorderSecondary}`,
                                justifyContent: 'flex-start',
                                textAlign: 'left',
                            }}
                            onClick={() => {
                                onSelect(field);
                                setOpen(false);
                            }}
                        >
                            <span style={{ display: 'flex', minWidth: 0, flexDirection: 'column', gap: '0.125rem' }}>
                                <span>{details.label}</span>
                                <small style={{ color: token.colorTextTertiary, fontWeight: 400 }}>
                                    {section.label}
                                </small>
                            </span>
                        </Button>
                    );
                })}
            </div>
        </div>
    );

    return (
        <Popover
            content={content}
            arrow={false}
            placement='bottomRight'
            trigger='hover'
            open={open}
            onOpenChange={setOpen}
        >
            <Tag bordered={false} color='gold' style={{ margin: 0 }}>
                <span
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.25rem',
                        verticalAlign: '-0.125rem',
                    }}
                >
                    <TbInfoCircle style={{ flex: '0 0 auto' }} />
                    <span>{fields.length} remaining</span>
                </span>
            </Tag>
        </Popover>
    );
};

export default RequiredFieldsPreviewPopover;
